import { TFunction } from "i18next";
import * as yup from "yup";

export interface NotificationValidationSchemeProps {
    t: TFunction;
}

export const NotificationValidationScheme = ({
    t,
}: NotificationValidationSchemeProps) => {

    const requiredMsg = t("validations.required");
    const requiredAtLeastOne = t("validations.requiredAtLeastOne");

    return yup.object().shape({
        title: yup.string().required(requiredMsg).max(250, t("validations.maximalStringLength", { maxLength: 250 })),
        message: yup.string().required(requiredMsg),
        validFrom: yup.date().required(requiredMsg).nullable(),
        roles: yup.array().of(yup.number()).min(1, requiredAtLeastOne)
    });

};